module.exports = __webpack_public_path__ + "static/media/landing-tab_Group401.47bc431b.png";